<span class="outer">
    <span class="inner">
        {{text}} {{number | number:'1.0-9':'de-DE'}} <mat-icon [matTooltip]="helpText | translate">help</mat-icon>
    </span>
</span>